<template>
  <div v-loading="loading" class="p-4px">
    <el-card shadow="never">
      <template #header>
        <div class="card-header">
          <span>机构信息</span>
          <el-tag v-if="org?.status" :type="statusTagType(org.status)" size="small">
            {{ statusLabel(org.status) }}
          </el-tag>
        </div>
      </template>

      <el-empty v-if="!loading && !org" description="暂无机构信息" />

      <template v-else-if="org">
        <div class="section-title">基本信息</div>
        <el-descriptions :column="2" border class="mb-16px">
          <el-descriptions-item label="机构名称">{{ org.name || '—' }}</el-descriptions-item>
          <el-descriptions-item label="机构 ID">{{ org.orgId || '—' }}</el-descriptions-item>
          <el-descriptions-item label="服务城市">{{ org.city || '—' }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ statusLabel(org.status) }}</el-descriptions-item>
          <el-descriptions-item label="信用代码">{{ org.licenseNo || '—' }}</el-descriptions-item>
          <el-descriptions-item label="法人姓名">{{ org.legalPerson || '—' }}</el-descriptions-item>
          <el-descriptions-item label="登录账号">{{ org.loginUsername || '—' }}</el-descriptions-item>
          <el-descriptions-item label="邀请码">{{ org.inviteCode || '—' }}</el-descriptions-item>
        </el-descriptions>

        <div class="section-title">联系信息</div>
        <el-descriptions :column="2" border class="mb-16px">
          <el-descriptions-item label="联系手机">{{ org.contactPhone || '—' }}</el-descriptions-item>
          <el-descriptions-item label="联系邮箱">{{ org.contactEmail || '—' }}</el-descriptions-item>
        </el-descriptions>

        <div class="section-title">资质材料</div>
        <el-descriptions :column="1" border class="mb-16px">
          <el-descriptions-item label="营业执照">
            <el-image
              v-if="org.licenseUrl"
              :src="org.licenseUrl"
              :preview-src-list="[org.licenseUrl]"
              style="width: 120px; height: 120px"
              fit="cover"
            />
            <span v-else>—</span>
          </el-descriptions-item>
          <el-descriptions-item label="身份证正面">
            <el-image
              v-if="org.idCardFront"
              :src="org.idCardFront"
              :preview-src-list="[org.idCardFront]"
              style="width: 120px; height: 120px"
              fit="cover"
            />
            <span v-else>—</span>
          </el-descriptions-item>
          <el-descriptions-item label="身份证反面">
            <el-image
              v-if="org.idCardBack"
              :src="org.idCardBack"
              :preview-src-list="[org.idCardBack]"
              style="width: 120px; height: 120px"
              fit="cover"
            />
            <span v-else>—</span>
          </el-descriptions-item>
        </el-descriptions>

        <el-alert
          v-if="org.rejectReason"
          class="mb-16px"
          type="warning"
          :closable="false"
          :title="`驳回原因：${org.rejectReason}`"
        />

        <div>
          <el-button @click="refresh">刷新</el-button>
          <el-button type="primary" link @click="$router.push('/store/capacity/invite')">
            去邀请骑手
          </el-button>
        </div>
      </template>
    </el-card>
  </div>
</template>

<script lang="ts" setup>
import * as OrgConsoleApi from '@/api/capacity/org-console'
import { ElMessage } from 'element-plus'

defineOptions({ name: 'MerchantCapacityProfile' })

const STATUS_LABEL: Record<string, string> = {
  pending: '待审',
  active: '已开通',
  rejected: '已驳回',
  suspended: '已停用',
  liquidating: '清算中',
  closed: '已归档'
}

const loading = ref(true)
const org = ref<OrgConsoleApi.OrgItem | null>(null)

const statusLabel = (s: string) => STATUS_LABEL[s] || s
const statusTagType = (s: string) => {
  if (s === 'active') return 'success'
  if (s === 'pending') return 'warning'
  if (s === 'rejected') return 'danger'
  return 'info'
}

const refresh = async () => {
  loading.value = true
  try {
    org.value = (await OrgConsoleApi.orgMyApply()) || null
    if (org.value?.orgId) {
      localStorage.setItem('capacityOrgId', org.value.orgId)
    }
  } catch {
    ElMessage.error('加载机构信息失败')
    org.value = null
  } finally {
    loading.value = false
  }
}

onMounted(refresh)
</script>

<style scoped lang="scss">
.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-title {
  font-weight: 600;
  margin: 0 0 12px;
  color: #303133;
}
</style>
